import styled from 'styled-components';
import { gridConfig as breakpoints } from '../../fuse-responsive-grid/src/grid';
import { style } from './config';

const { background, boxShadow, padding } = style;

const StyledStickyDrawer = styled.div.attrs({
	className: 'fuse-sticky-drawer',
})`
	background: ${background};
	bottom: 0;
	box-shadow: ${boxShadow};
	left: 0;
	margin: 0;
	padding: ${padding.small};
	position: fixed;
	right: 0;
	width: 100%;
	will-change: transform, visibility, height;
	${({ open, transition, zIndex }) => `
		transition: ${transition};
		transform: ${open ? `translateY(0%)` : `translateY(100%)`};
		visibility: ${open ? `visible` : `hidden`};
		z-index: ${zIndex};
	`}

	/* Responsive size override for tablet */
	@media screen and (min-width: ${breakpoints.m.minWidth}) {
		padding: ${padding.medium};
	}

	/* For desktop, sticky drawer is not shown */
	@media screen and (min-width: ${breakpoints.l.minWidth}) {
		display: none;
	}
`;

export default StyledStickyDrawer;
